import { adminValidationMetadata } from './admin-validation-metadata';
import { billValidationMetadata } from './bill-validation-metadata';
import { customPropertyValidationMetadata } from './custom-property-validation-metadata';
import { portalpracticeValidationMetadata } from './portalpractice-entry-validation-metadata';
import { timeEntryValidationMetadata } from './time-entry-validation-metadata';
import { timeImportValidationMetadata } from './time-import-validation-metadata';

export const validationMetadata = [
  { global: { validators: ['breeze'] } },
  adminValidationMetadata,
  billValidationMetadata,
  timeEntryValidationMetadata,
  timeImportValidationMetadata,
  customPropertyValidationMetadata,
  portalpracticeValidationMetadata
];
